import { VARIANT_COLOR_ENUM } from '@/types/utils';
import clx from 'classnames';
import { TYPE_TO_BOX_CLASS, TYPE_TO_ICON } from 'context/Toaster/ToastView/consts';
import React from 'react';

type Props = {
  children: React.ReactNode;
  icon?: string;
  variant: VARIANT_COLOR_ENUM;
  className?: string;
};
const AlertTool = ({ children, icon, variant, className }: Props) => (
  <div className={clx(TYPE_TO_BOX_CLASS[variant], 'rounded-lg border-2')}>
    <div className={clx('flex flex-row items-center p-3 gap-4 justify-start', className)}>
      {icon && <i className={clx(icon || TYPE_TO_ICON[variant])} />}
      {children}
    </div>
  </div>
);

export default AlertTool;
